import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  textField: {
    minWidth: "80px",
    height: "2.4rem",
    "& .MuiInputBase-root": {
      fontSize: "0.875rem",
      paddingY: "0"
    },
    "& .MuiInputLabel-root": {
      paddingLeft: "5px",
    },
    "& .MuiFocused": {
      backgroundColor: "transparent",
    },
    "& .MuiOutlinedInput-input:-webkit-autofill": {
      paddingTop: "2%",
      paddingBottom: "2%",
    },
  },
  selectAdornment: ({ selectFieldPosition }) => ({
    fontSize: "0.875rem",
    minWidth: "80px",
    textAlign: selectFieldPosition === "end" ? "right" : "left",
    padding: "1px 8px",
    borderLeft: selectFieldPosition === "end" ? "1px rgba(0, 0, 0, 0.23) solid" : "none",
    borderRight: selectFieldPosition === "start" ? "1px rgba(0, 0, 0, 0.23) solid" : "none",
    "& .MuiSelect-select:focus": {
      backgroundColor: "transparent",
    },
  }),
  inputLabel: {
    fontSize: "1rem",
    transform: "translate(8px, 12px)",
    paddingLeft: "8px",
    marginBottom: "50px",
    backgroundColor: "transparent",
    paddingRight: "5px",
  },
  selectRoot: {
    "& .MuiSelect-root": {
      backgroundColor: "transparent",
      "&:focus": {
        backgroundColor: "transparent",
      },
    },
  },
  menuItem: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
}));
